import LandingPageBannerBlock from './LandingPageBannerBlock';
import { LandingPageBannerBlockProps, LandingPageBannerBlockValueProps } from './types';

export type { LandingPageBannerBlockProps, LandingPageBannerBlockValueProps };
export default LandingPageBannerBlock;
